module.exports = __webpack_public_path__ + "img/icon-mobile-app-tablet.1fdd83fd.svg";